/** Enumerador com os tipos possíveis de linhas de contratos.
 * @category Contracts
 */
export const enum ERowTypes {
  STAGE = 0,
  RESOURCE = 1,
}

/** Enumerador com os status dos contratos.
 * @category Contracts
 */
export enum EContractStatus {
  AGUARDANDO = "aguardando",
  ANDAMENTO = "andamento",
  PARALISADO = "paralisado",
  CONCLUIDO = "concluido",
  ARQUIVADO = "arquivado",
}

/** Enumerador com os tipos possíveis de base de cálculo para retenção técnica do contrato.
 * @category Contracts
 */
export enum ETechnicalRetentionType {
  MEASUREMENT = "measurementTotal",
  GROSSTOTAL = "grossTotal",
}

export enum ERowStatus {
  UNCHAGED = "unchanged",
  CHANGED = "changed",
  CANCELED = "canceled",
}
